import { matchPath } from 'react-router-dom';

export default function getAppIdFromUrl(): null | string {
  const match = matchPath<{ appId: string }>(window.location.pathname, {
    path: '/trace/:appId',
  });

  return match && match.params.appId;
}
